export default "__VITE_ASSET__Bu51f1Da__"